import { form } from '../../formState'

import { CompaniesAccess } from './CompaniesAccess'
import { CompaniesList } from './CompaniesList'

type Props = {
  creating: boolean
}

export function Companies(props: Props) {
  const { creating } = props
  const isCompanyFilteredField = form.useFormField('isCompanyFiltered')
  const showList = isCompanyFilteredField.field.value

  return (
    <form.Fieldset>
      <CompaniesAccess />
      {showList && <CompaniesList creating={creating} />}
    </form.Fieldset>
  )
}
